import { getHttp } from '@/api/httpFactory';
import { API_URLS } from './urls';

const http = getHttp(import.meta.env.VITE_API_BASE_URL);

const userApi = {
    /**
     * Get a verify code for new users
     */
    async fetchVerifyCode() {
        const resp = await http.get(API_URLS.VERIFY_CODE.GET);

        return resp;
    },

    /**
     * Submit the new terms of use
     */
    async submitAcceptTerms() {
        const resp = await http.post(API_URLS.AUTH.ACCEPT_TERMS);

        return resp;
    },

    /**
     * Get all data of logged user
     * @returns
     */
    async fetchMe() {
        const resp = await http.post(API_URLS.AUTH.ME);

        return resp;
    },

    /**
     * Get all utils infos for profile
     * @returns
     */
    async fetchUtils() {
        const resp = await http.get(API_URLS.AUTH.UTILS);

        return resp;
    },

    /**
     * Logout the current user
     */
    async logout() {
        await http.post(API_URLS.AUTH.LOGOUT);
    },
};

export default userApi;
